import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { TranslationId } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { IconName } from '../../icons';
import { ModalService } from '../modal.service';

/**
 * Styled with:
 * - --mod-content-border-radius: the border radius of mod-content
 * - --modal-header-part-display: the display property of mod-header-part
 * - --modal-header-part-flex-direction: the flex-direction property of mod-header-part
 * - --modal-header-part-flex-direction: the flex-direction property of mod-header-part
 * - --mod-header-padding: the padding of mod-header-part
 * - --mod-header-height: the height of mod-header-part
 * - --mod-header-background-color: the background color of mod-header
 * - --mod-header-border-bottom: the border-bottom of mod-header
 * - --mod-header-border-radius: the border radius of mod-header
 * - --mod-body-padding: the padding of mod-body
 * - --mod-body-background-color: the background color of mod-mody
 * - --mod-body-border-radius: the border radius of mod-body
 * - --modal-header-h2-font-family: the font family of h2
 * - --modal-header-h2-font-size: the font size of h2
 * - --modal-header-h2-margin: the margins of h2
 * - --modal-header-h2-padding: the paddings of h2
 * - --mod-h2-display: the display property of h2
 */

@Component({
  selector: 'yat-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  @Input()
  header?: string | TranslationId;

  @Input()
  showCloseIcon: boolean = false;

  @Input()
  tooltip?: string;

  @Input()
  icon?: IconName;

  @Input()
  iconClass?: string;

  @ContentChild('body', { static: true })
  body: TemplateRef<void>;

  @ContentChild('footer', { static: true })
  footer: TemplateRef<void>;

  showNotifications$: Observable<boolean>;

  ngOnInit(): void {
    this.showNotifications$ = this.modalService.hasNotifications();
  }

  closeModal(): void {
    this.modalService.closeCurrent().subscribe();
  }

  getHeaderAsTranslationId(): TranslationId | undefined {
    return this.header !== undefined && typeof this.header === 'object' ? (this.header as TranslationId) : undefined;
  }
}
